import { defineComponent as _defineComponent } from 'vue'
import { computed, inject, onMounted, ref } from "vue";
import SegmentedControl from "@/components/shared/SegmentedControl.vue";
import NavigationBar from "@/components/shared/NavigationBar.vue";
import { useGuideStore } from "@/stores/guideStore";
import { PROVIDE_KEY_SHOW_ERROR_MODAL, ShowErrorModal } from "@/types";
import { IGuideInfoData } from "@/domain/entities/guide";
import DOMPurify from "dompurify";


const __default__ = {
  name: "NewRouteApplicationGuide",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  emits: ["onClickClose"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const emit = __emit;
const showErrorModal = inject(PROVIDE_KEY_SHOW_ERROR_MODAL) as ShowErrorModal;

const guideStore = useGuideStore();
const operationInfos = ref<IGuideInfoData[]>([]);

const guideTitles = computed(() =>
  operationInfos.value.map((operationInfo) => operationInfo.title)
);
const currentSegmentIndex = ref(0);
const onChangedSegmentIndex = (index: number) => {
  currentSegmentIndex.value = index;
};

const emitOnClickClose = () => {
  emit("onClickClose");
};

const getOperationInfos = async () => {
  const operationInfosResult = await guideStore.getOperationInfos();
  if (!operationInfosResult.isSuccess) {
    showErrorModal(
      "유의사항 조회 오류",
      operationInfosResult.errorMessage,
      operationInfosResult.resultCode,
      operationInfosResult.errorTime,
      emitOnClickClose
    );
    return;
  }
  operationInfos.value = operationInfosResult.data ?? [];
};

onMounted(() => {
  getOperationInfos();
});

const __returned__ = { emit, showErrorModal, guideStore, operationInfos, guideTitles, currentSegmentIndex, onChangedSegmentIndex, emitOnClickClose, getOperationInfos, SegmentedControl, NavigationBar, get DOMPurify() { return DOMPurify } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})